export default __webpack_public_path__ + "static/media/left-arrow.3fad956f.svg";